export default function createQueryString(parameters: { [key: string]: string | number }): string {
  return Object.entries(parameters)
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&');
}
